import axios from "axios";
import { apiErrorHandler } from "./helper/handler";

const prefix = "marketing-news";

const GET_ALL_MARKETING_NEWS_URL = `${prefix}/all`;
const CREATE_MARKETING_NEWS_URL = `${prefix}/create`;
const UPDATE_MARKETING_NEWS_BY_ID_URL = `${prefix}/update-by-id`;
const DELETE_MARKETING_NEWS_BY_ID_URL = `${prefix}/delete-by-id`;

/**
 * @func getAllMarketingNews
 * @desc get all news data
 * @author izeberg
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} news array
 */
export const getAllMarketingNews = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_ALL_MARKETING_NEWS_URL, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getAllMarketingNews");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getAllMarketingNews */

/**
 * @func createMarketingNews
 * @desc create new news
 * @author izeberg
 * @param {Object} body - create news body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean} create status
 */
export const createMarketingNews = async (body, signal) => {
    try {
        const { status } = await axios.post(CREATE_MARKETING_NEWS_URL, body, {
            signal,
        });
        if (status === 201) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "createMarketingNews");
        if (err) throw err;
        return undefined;
    }
};
/** End @func createMarketingNews */

/**
 * @func updateMarketingNewsById
 * @desc update news by id
 * @author izeberg
 * @param {number} id - news id
 * @param {Object} body - update news body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean} update status
 */
export const updateMarketingNewsById = async (id, body, signal) => {
    try {
        const { status } = await axios.put(`${UPDATE_MARKETING_NEWS_BY_ID_URL}/${id}`, body, {
            signal,
        });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "updateMarketingNewsById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func updateMarketingNewsById */

/**
 * @func deleteMarketingNewsById
 * @desc delete news by id
 * @author izeberg
 * @param {Object} body - create news body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} news array
 */
export const deleteMarketingNewsById = async (id, signal) => {
    try {
        const { status } = await axios.delete(`${DELETE_MARKETING_NEWS_BY_ID_URL}/${id}`, {
            signal,
        });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "deleteMarketingNewsById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func deleteMarketingNewsById */
